import { render, staticRenderFns } from "./ConfigLotteryQualification.vue?vue&type=template&id=4fff7ce9&scoped=true"
import script from "./ConfigLotteryQualification.vue?vue&type=script&lang=ts"
export * from "./ConfigLotteryQualification.vue?vue&type=script&lang=ts"
import style0 from "./ConfigLotteryQualification.vue?vue&type=style&index=0&id=4fff7ce9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fff7ce9",
  null
  
)

export default component.exports